export interface IInsurer {
  id: string;
  description: string;
  active: boolean;
}

export interface IInsurersDetails {
  active?: boolean;
  description?: string;
  holiday_period_cover?: boolean;
  id?: number;
  insurer_id?: string;
  product?: string;
  product_code?: string;
  product_insurer?: string;
  provider?: string;
  type?: string;
  contact_number?: string;
  img_source?: string;
}
